import { isObjectRecord } from "../../typeGuards";
import { ArsTableCellType, ArsTableRowOperationCell } from "../interface";
import { isArsTableCellBase } from "./isArsTableCellBase";

/**
 * Type guard for ArsTableRowOperationCell, which is a possible type of ArsTableCellBase.
 *
 * @param obj - The object to check
 * @param isT - A type guard function for the generic type T used in the cell's displayContent and annotationContent
 * @returns - True if the object is an ArsTableRowOperationCell, false otherwise
 */
export const isArsTableRowOperationCell = <T = string>(
  obj: unknown,
  isT: (value: unknown) => value is T,
): obj is ArsTableRowOperationCell<T> => {
  if (!isObjectRecord(obj)) return false;
  if (!isArsTableCellBase<T>(obj, isT)) return false;

  if (obj.cellType !== ArsTableCellType.RowOperation) return false;
  if (!["number", "undefined"].includes(typeof obj.decimalAlignPercentage)) return false;
  if (!["number", "undefined"].includes(typeof obj.height)) return false;
  if (!["boolean", "undefined"].includes(typeof obj.hidden)) return false;
  if (typeof obj.targetId !== "string") return false;

  // Everything is good
  return true;
};
